"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT = exports.PROJECTS = void 0;
const __1 = require("..");
const menu_1 = require("./menu");
exports.PROJECTS = __1.ADMIN.child("/projects");
exports.PROJECT = __1.ADMIN.child("/projects/:projectId", undefined, {
    components: { menu: menu_1.ProjectMenu },
});
